import { module } from './store'
import { createModule } from '@vue-storefront/core/lib/module'
import { initCacheStorage } from '@vue-storefront/core/helpers/initCacheStorage'
import { afterRegistration } from './hooks/afterRegistration'

export const KEY = 'recommended'
export const cacheStorage = initCacheStorage(KEY)
export const Recommended = createModule({
  key: KEY,
  store: { modules: [{ key: KEY, module }] },
  afterRegistration
})
